import { config } from 'utils/config';

const API_TAGS_PATH = '/v2/public/ui/tags';
export const NEXT_API_BASE_URL = `${config.appUrl}/api${API_TAGS_PATH}`;
export const API_BASE_URL = `${config.apiUrl}${API_TAGS_PATH}`;
export const TESTING_TAGS_PREFIX = 'PRACTICES/DEVELOPMENT/TESTING';
